import type stockTransferId from "./id";

const stockTransferEn: typeof stockTransferId = {
	stock_transfer: {
		title: "Stock Transfer",
		subtitle: "List of stock transfer between stores",
		table: {
			title: "Stock transfer Data",
			columns: {
				date: "Date",
				ref_id: "Ref ID",
				from_store: "Source Store",
				to_store: "Destination Store",
				notes: "Notes",
				created_by: "Created By",
				status: "Status",
			},
		},
		empty_state: {
			title: {
				has_filter: "No matching data",
				no_filter: "No stock transfer data",
			},
			description: {
				has_filter:
					"No data found with the selected filter. Try to change your filter.",
				no_filter: "Please add new stock transfer data.",
			},
		},
		forms: {
			edit: {
				title: "Edit Stock Transfer",
				info: "Stock transfer information",
				fields: {
					ref_id: {
						label: "RefId",
						placeholder: "refId",
					},
					from_store: {
						label: "Source Store",
						placeholder: "Select Store",
					},
					to_store: {
						label: "Destination Store",
						placeholder: "Select Store",
					},
					notes: {
						label: "Notes",
						placeholder: "notes",
					},
					status: {
						label: "Status",
						placeholder: "Select Status",
					},
				},
				options: {
					active: "Active",
					inactive: "Inactive",
				},
			},
			conflict: {
				same_store: "Destination store cannot be the same as the source store",
				transfer_stock_out_of_stock:
					"The amount of transfer exceeds the initial stock",
			},
			add: {
				button: "Add Stock Transfer",
				title: "Add Stock Transfer",
				description: "Add new Transfer Stock data",
				fields: {
					from_store: {
						label: "Source Store",
						placeholder: "Select store",
					},
					to_store: {
						label: "Destination Store",
						placeholder: "Select store",
					},
					notes: {
						label: "Notes",
						placeholder: "Enter Notes",
					},
					processed_at: {
						label: "Process Date",
					},
					product_detail: {
						title: "Product Detail",
						from_product: {
							label: "Source Product",
							placeholder: "Select Product",
							search_product: "Search Product...",
							not_found_product: "No product found",
						},
						from_stock: {
							label: "Source Stock",
							placeholder: "0",
						},
						to_stock: {
							label: "Destination Stock",
							placeholder: "0",
						},
						to_last_stock: {
							label: "Destination Last Stock",
							placeholder: "0",
						},
						to_product: {
							label: "Destination Product",
							placeholder: "Select Product",
							search_product: "Search Product...",
							not_found_product: "No product found",
						},
						qty: {
							label: "QTY",
							placeholder: "0",
						},
						unit: {
							label: "Unit",
							placeholder: "Pcs",
						},
						action: {
							label: "Action",
						},
					},
				},
			},
		},
		status: {
			processed: "Processed",
			inactive: "Inactive",
			active: "Active",
		},
		actions: {
			save: "Save",
			saving: "Saving...",
			cancel: "Cancel",
			save_changes: "Save Changes",
			add_products: {
				already_added: "This Product already added",
				button: "Add more Product",
			},
		},
	},
};

export default stockTransferEn;
